var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.psp=='PASARGAD')?_c('pasargad',{attrs:{"form_data":_vm.parent}}):_vm._e(),(_vm.psp=='NOVIN')?_c('novin',{attrs:{"form_data":_vm.parent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }